<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
    <keep-alive :exclude="exclude">
      <router-view class="child-view "></router-view>
    </keep-alive>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      transitionName: 'slide-left',
      exclude: ""
    }
  },
  //监听路由的路径，可以通过不同的路径去选择不同的切换效果
  watch: {
    '$route' (to, from) {
      this.transitionName = isBack ? 'slide-right' : 'slide-left';
      if (isBack) {
        this.exclude = from.name;
      } else {
        this.exclude = "";
      }
      console.log('this.exclude:' + this.exclude);
      isBack = false;
      if (GOBACKTOPAGE) {
        if (GOBACKTOPAGE == to.name) {
          GOBACKTOPAGE = undefined;
        } else {
          window.gobackTo(GOBACKTOPAGE);
        }
      }
    }
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: #404040;
  margin-top: 10px;
}
.child-view {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  /*高度*/
  /*height: 100%;*/
  bottom: 0;
  /*新增*/
  overflow: hidden;
  transition: all 0.6s cubic-bezier(0.55, 0, 0.1, 1);
}
.slide-left-enter,
.slide-right-leave-active {
  opacity: 0;
  -webkit-transform: translate(300px, 0);
  transform: translate(300px, 0);
}
.slide-left-leave-active,
.slide-right-enter {
  opacity: 0;
  -webkit-transform: translate(-300px, 0);
  transform: translate(-300px, 0);
}
.mui-popup-text {
  padding-left: 10px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue